import { useState, useEffect } from 'react';

interface User {
  id: number;
  username: string;
  nome: string;
  nm_acesso?: string;
  nm_setor?: string;
  modules: string[];
}

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  // Verificar token válido na inicialização
  useEffect(() => {
    // Limpar chaves legadas que podem ter sido gravadas por versões antigas do sistema
    ['nome', 'user', 'setor', 'loginTime'].forEach(key => localStorage.removeItem(key));

    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // Verificar se o token é válido fazendo uma requisição para o backend
        const response = await fetch('/api/auth/verify', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData.user);
        } else {
          // Token inválido, remover do localStorage
          localStorage.removeItem('token');
        }
      } catch (error) {
        console.error('Erro ao verificar autenticação:', error);
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = (userData: User, token: string) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user
  };
};